export const VELOTTERY_ICON_SRC = "/velottery.png";
export const VELOTTERY_ICON_CLASS = "h-5 w-5 object-contain flex-shrink-0 mt-0.5";

export const VELOTTERY_TICKET_PURCHASE_CLASS = "velottery_ticket_purchase";

const VELOTTERY_SUBTITLES = {
  velottery_ticket_purchase: "Paid Lottery Ticket",
};

export function normalizeVeLotteryClassification(value) {
  return String(value || "")
    .trim()
    .toLowerCase()
    .replace(/[\s-]+/g, "_")
    .replace(/_+/g, "_");
}

export function isVeLotteryClassification(value) {
  return normalizeVeLotteryClassification(value).startsWith("velottery_");
}

export function getVeLotteryDisplay(value) {
  const cls = normalizeVeLotteryClassification(value);
  if (!cls.startsWith("velottery_")) return null;

  const subtitle =
    VELOTTERY_SUBTITLES[cls] ||
    cls
      .replace(/^velottery_/, "")
      .split("_")
      .filter(Boolean)
      .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
      .join(" ") ||
    "Interaction";

  return {
    title: "VeLottery",
    subtitle,
  };
}
